export default __webpack_public_path__ + "static/media/before-you-start.f5cbc8e2.svg";